import { MAP_MISSION_TYPE } from "@/utils/constants/corpus";
import { Typography } from "@mui/material";
import { FC } from "react";

interface LastMissionColumnProps {
  lastMission?: string;
}

const LastMissionColumn: FC<LastMissionColumnProps> = ({ lastMission }) => {
  if (!lastMission) return <Typography>-</Typography>;

  return <Typography>{MAP_MISSION_TYPE[lastMission as MissionType]}</Typography>;
};

export default LastMissionColumn;
